import React from 'react';

import { IconProps } from './types';

const Play: React.FC<IconProps> = () => {
  return (
    <svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.62457 7.34794C1.43938 7.46831 1.25179 7.47517 1.06179 7.3685C0.872159 7.2622 0.777344 7.09794 0.777344 6.87572V1.12572C0.777344 0.9035 0.872159 0.739056 1.06179 0.632389C1.25179 0.526093 1.43938 0.53313 1.62457 0.6535L6.15234 3.5285C6.31901 3.63961 6.40234 3.79702 6.40234 4.00072C6.40234 4.20443 6.31901 4.36183 6.15234 4.47294L1.62457 7.34794Z"
        fill="white"
      />
    </svg>
  );
};

export default Play;
